import { Switch } from '@headlessui/react';
import clsx from 'clsx';

export interface IToggleButtonProps {
  isActive: boolean;
  onHandleToggle: (value: boolean) => void;
}

/**
 * -----------------------------------------------------------------------------
 * A reusable headless ui toggle button.
 */
export function ToggleButton({ isActive, onHandleToggle }: IToggleButtonProps) {
  return (
    <Switch
      checked={isActive}
      className={clsx(
        `
          focus:ring-primary-400 -z-1 relative inline-flex h-6 w-11 flex-shrink-0
          cursor-pointer rounded-full border-2 border-transparent transition-colors
          duration-200 ease-in-out focus:outline-none focus:ring-1
          focus:ring-offset-2
        `,
        isActive ? 'bg-primary-400' : 'bg-gray-200'
      )}
      onChange={onHandleToggle}
    >
      <span className="sr-only">Use setting</span>
      <span
        className={clsx(
          isActive
            ? 'translate-x-5 rtl:translate-x-0'
            : 'translate-x-0: rtl:-translate-x-5'
        )}
      >
        <span
          aria-hidden="true"
          className={clsx(
            isActive
              ? 'opacity-0 duration-100 ease-out'
              : 'opacity-100 duration-200 ease-in'
          )}
        >
          <svg
            className="h-3 w-3 text-gray-400"
            fill="none"
            viewBox="0 0 12 12"
          >
            <path
              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
            />
          </svg>
        </span>
        <span
          aria-hidden="true"
          className={clsx(
            isActive
              ? 'opacity-100 duration-500 ease-in'
              : 'opacity-0 duration-300 ease-out'
          )}
        >
          <svg
            className="text-primary-700 h-3 w-3"
            fill="currentColor"
            viewBox="0 0 12 12"
          >
            <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
          </svg>
        </span>
      </span>
    </Switch>
  );
}
